import { Stack, Typography } from "@mui/material";
import FileIcon from "@entrilia/shared/components/FileIcon";
import { getFileExtension } from "@entrilia/shared/utilities/fileHelper";
import type { DocumentViews } from "../../../../api/types/documentActivityTypes";
import { useDocumentViewsGridContext } from "./DocumentViewsGridContext";

interface Props {
  row: DocumentViews;
}

const DocumentViewsGridFileNameCell = ({ row }: Props) => {
  const { showFilePreview } = useDocumentViewsGridContext();

  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: "center", width: "100%" }}>
      <FileIcon fileExtension={getFileExtension(row.documentInfo.fileName)} />
      <Typography
        noWrap
        sx={(t) => ({ cursor: "pointer", "&:hover": { color: t.palette.primary.main } })}
        onClick={() => showFilePreview(row)}
      >
        {row.documentInfo.fileName}
      </Typography>
    </Stack>
  );
};

export default DocumentViewsGridFileNameCell;
